// Internal Imports
import { GlobalUtils } from "../../utils";
import { USER_ROLES } from "../../constants/roleList";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;

// eslint-disable-next-line import/prefer-default-export
export const checkAssetPermission = (itemAccessLevel, actionType) => {
  const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
  let currentUserRole = null;
  if (CURRENT_USER && CURRENT_USER.roles) {
    currentUserRole = CURRENT_USER.roles[0].name;
  }
  let hasPersmission = false;
  if (currentUserRole === USER_ROLES.USER) {
    if (itemAccessLevel === "EDIT") {
      if (actionType === "MOVE" || actionType === "DISABLE_CHECKBOX") {
        hasPersmission = false;
      } else if (actionType === "CREATE" || actionType === "ENABLE_CHECKBOX") {
        hasPersmission = true;
      } else {
        hasPersmission = true;
      }
    } else if (itemAccessLevel === "VIEW") {
      hasPersmission = false;
    } else if (itemAccessLevel === "OWNER") {
      hasPersmission = true;
    }
  } else {
    hasPersmission = true;
  }

  return hasPersmission;
};



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/method.js